import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from 'components/UI/Buttons/Button/Button';
import Modal from 'components/Common/MUIModal/Modal';
import ModalHeader from 'components/Common/MUIModal/ModalHeader';
import ModalBody from 'components/Common/MUIModal/ModalBody';
import ModalActions from 'components/Common/MUIModal/ModalActions';

import styles from './ModalDeleteProduct.module.scss';

function ModalDeleteProduct({
  closeModal,
  deleteProduct,
  isOpen,
  modelName,
}: {
  closeModal: () => void;
  deleteProduct: () => void;
  isOpen: boolean;
  modelName: string;
}): JSX.Element | null {
  const { t } = useTranslation();

  return (
    <Modal open={isOpen} onCloseClickAway={closeModal}>
      <ModalHeader onClose={closeModal}>
        <h1 className={styles.title}>{t('LABEL_SHOULD_DELETE_PRODUCT')}</h1>
      </ModalHeader>
      <ModalBody className={styles.body}>
        <span>
          {t('LABEL_YOU_ARE_ABOUT_TO_DELETE_PRODUCT', {
            modelName: modelName,
          })}
        </span>
        <br />
        <span>{t('LABEL_WOULD_LIKE_TO_CONFIRM_THIS_CHOICE')}</span>
      </ModalBody>
      <ModalActions className={styles.footer}>
        <Button
          className={styles.confirm}
          type={'button'}
          onClick={() => {
            deleteProduct();
            closeModal();
          }}
        >
          {t('LABEL_DELETE_PRODUCT')}
        </Button>
        <Button className={styles.cancel} type={'button'} onClick={closeModal}>
          {t('LABEL_CANCEL')}
        </Button>
      </ModalActions>
    </Modal>
  );
}

export default ModalDeleteProduct;
